// extracted by mini-css-extract-plugin
export default {"heading":"aA-z","corrected":"bA-z","redirectVerbiageContainer":"cA-z","redirectVerbiageText":"dA-z"};